module.exports = __webpack_public_path__ + "img/IMG_2536-2.c6c542e9.jpg";